import { StoryblokServerComponent } from "@storyblok/react/rsc";
import { Carousel } from "~components/ui/carousel/carousel";
import { cn } from "~utils";
import type { SectionBlockHeaderProps } from "./types";

export function SectionCarousel({
  blok,
  ...context
}: Readonly<SectionBlockHeaderProps>) {
  // GAP
  const gap = blok.gap;

  return (
    <Carousel className={cn(gap)}>
      {blok?.items?.map(nestedBlok => (
        <StoryblokServerComponent
          blok={nestedBlok}
          key={nestedBlok._uid}
          {...context}
        />
      ))}
    </Carousel>
  );
}
